"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageUrlForTrait = exports.getImageUrlForToken = exports.ImageFileType = exports.encodeLayerFlags = exports.setImageServiceBaseURI = void 0;
const types_1 = require("@chain-runners/types");
const traits_1 = require("./traits");
const IMAGE_API_CONFIG = {
    baseURI: 'https://img.chainrunners.xyz',
};
function setImageServiceBaseURI(baseURI) {
    IMAGE_API_CONFIG.baseURI = baseURI;
}
exports.setImageServiceBaseURI = setImageServiceBaseURI;
function encodeLayerFlags(hiddenTraits) {
    const flags = Object.values(types_1.TraitType)
        .filter((traitType) => hiddenTraits[traitType])
        .map((traitType) => traits_1.ALL_TRAIT_ORDERING.indexOf(traitType));
    if (!flags.length)
        return;
    return Buffer.from(JSON.stringify(flags)).toString('base64');
}
exports.encodeLayerFlags = encodeLayerFlags;
var ImageFileType;
(function (ImageFileType) {
    ImageFileType["svg"] = "svg";
    ImageFileType["png"] = "png";
})(ImageFileType = exports.ImageFileType || (exports.ImageFileType = {}));
function getImageUrlForToken(tokenId, hiddenTraits, fileType = ImageFileType.png) {
    const layerFlags = hiddenTraits ? encodeLayerFlags(hiddenTraits) : undefined;
    const params = layerFlags ? `?layerFlags=${layerFlags}` : '';
    return `${IMAGE_API_CONFIG.baseURI}/api/v1/tokens/${fileType}/${tokenId}${params}`;
}
exports.getImageUrlForToken = getImageUrlForToken;
function getImageUrlForTrait(traitId, fileType = ImageFileType.png) {
    return `${IMAGE_API_CONFIG.baseURI}/api/v1/traits/${fileType}/${traitId}.${fileType}`;
}
exports.getImageUrlForTrait = getImageUrlForTrait;
//# sourceMappingURL=images.js.map